module.exports = __webpack_public_path__ + "static/media/designPatent_30-0992964.1d467c1b.png";